// Utility to resolve a color string to a valid CSS color, with fallback
export function getColor(color: string | null | undefined, fallback: string): string {
  if (!color) return fallback;
  if (color.startsWith('#') || color.startsWith('rgb') || color.startsWith('hsl')) return color;
  if (/^[0-9A-Fa-f]{6}$/.test(color)) return `#${color}`;
  return fallback;
} 